import reportModel from '../../models/report';
import ReducerUtilities from '../../../shared/store/reducer-utilities';
import trainingPhasesCommitTypes from './commit-types';

const INITIAL_TRAINING_PHASES_STATE = {
  isAddingObservationReport: null,
  isAddingScheduledReport: null,
  isEditingReport: null,
  isEditingReportModalOpened: false,
  isLoading: [],
  isSchedulingReports: false,
  isViewingReport: null,
  reports: null,
  selectedGuid: null,
  selectedTrainingPhaseModal: false,
  trainingPhasesReports: {}
};

function tPPhasesReducers(state = INITIAL_TRAINING_PHASES_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case trainingPhasesCommitTypes.PUSH_TRAINING_PHASE_REPORT:
      return {
        ...state,
        reports: [...(state.reports || []), reportModel(action.report)],
      };
    case trainingPhasesCommitTypes.PUSH_TRAINING_PHASE_REPORTS:
      return {
        ...state,
        reports: !state.reports
          ? action.reports.map(report => reportModel(report))
          : [
            ...state.reports,
            ...action.reports.map(report => reportModel(report)),
          ],
      };
    case trainingPhasesCommitTypes.REPLACE_TRAINING_PHASE_REPORTS:
      return {
        ...state,
        reports: action.reports.map(report => reportModel(report))
      };
    case trainingPhasesCommitTypes.REMOVE_TRAINING_PHASE_REPORT:
      return {
        ...state,
        reports: [
          ...ReducerUtilities.removeModelFromList(
            action.reportGuid,
            state.reports,
          ),
        ],
      };
    case trainingPhasesCommitTypes.REPLACE_TRAINING_PHASE_REPORT:
      return {
        ...state,
        reports: state.reports
          ? [...ReducerUtilities.replaceModelInList(
              reportModel(action.report),
              state.reports,
            )]
          : null,
      };
    case trainingPhasesCommitTypes.RESET_TP_PHASES_STATE:
      return {...INITIAL_TRAINING_PHASES_STATE};
    case trainingPhasesCommitTypes.SET_SELECTED_TRAINING_PHASE:
      return {
        ...state,
        selectedGuid: action.selectedGuid,
      };
    case trainingPhasesCommitTypes.SET_SELECTED_TRAINING_PHASE_MODAL:
      return {
        ...state,
        selectedTrainingPhaseModal: action.modalOpened,
      };
    case trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_ADDING_OBSERVATION_REPORT:
      return {
        ...state,
        isAddingObservationReport: action.isAddingObservationReport,
      };
    case trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_ADDING_SCHEDULED_REPORT:
      return {
        ...state,
        isAddingScheduledReport: action.isAddingScheduledReport,
      };
    case trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_EDITING_REPORT:
      return {
        ...state,
        isEditingReport: action.isEditingReport,
      };
    case trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_EDITING_REPORT_MODAL_OPENED:
      return {
        ...state,
        isEditingReportModalOpened: action.modalOpened,
      };
    case trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };
    case trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_SCHEDULING_REPORTS:
      return {
        ...state,
        isSchedulingReports: action.isSchedulingReports,
      };
    case trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_VIEWING_REPORT:
      return {
        ...state,
        isViewingReport: action.isViewingReport,
      };
    case trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_VIEWING_REPORT_MODAL_OPENED:
      return {
        ...state,
        isViewingReportModalOpened: action.modalOpened,
      };
    case trainingPhasesCommitTypes.SET_TRAINING_PHASES_REPORTS:
      return {
        ...state,
        reports: action.reports.map(report => reportModel(report)),
        trainingPhasesReports: {
          ...state.trainingPhasesReports,
          [action.phaseGuid]: action.reports.map(report => reportModel(report))
        }
      };
    default:
      return state;
  }
}

export default tPPhasesReducers;
